/// <amd-module name="TFS/Admin/Common/Contracts/IOrganizationIdentity" />
export interface IOrganizationIdentity {
    entityType: string;
    localId?: string;
}
